__turbopack_context__.v({
  "codeWrapper": "CodeBlock-module__Ms8NyW__codeWrapper",
  "heading": "CodeBlock-module__Ms8NyW__heading",
  "root": "CodeBlock-module__Ms8NyW__root",
});
